(function ($) {
	'use strict';

	if ($('.testimonial-wall').length === 0) {
		return;
	}

	$(document).on('twitter-load', function () {
		$('.testimonial-wall').masonry();
	});

})(window.jQuery);
